import { html } from '../lib/html.js';
import { icon } from '../lib/icons.js';
import { getIndex } from '../lib/content.js';
import { topbar } from '../components/chrome.js';

const GROUPS = [
  ['dialogue', 'The four voices', 'Every verse is spoken by one of these four.'],
  ['pandava', 'The Pandavas and their allies', "Arjuna's side: five brothers wronged by their cousins."],
  ['kaurava', 'The Kauravas', "Dhritarashtra's sons and their champions."],
  ['elders', 'Elders and teachers', 'Revered figures bound to fight, or to watch.'],
];

export function deva(p) {
  const m = p.sa.match(/^.[ा-्ँ-ः]*/);
  return m ? m[0] : p.sa[0];
}

export default async function people() {
  const idx = getIndex();
  return {
    title: "Who's who",
    html: html`<div>
      ${topbar({ back: '/explore', title: "Who's who" })}
      <header class="wrap page-head">
        <p class="eyebrow">${idx.people.length} people</p>
        <h1 class="h1">Who's who</h1>
        <p class="lede">The Gita has a small cast and a large family. Here is everyone you will meet, and how they are related.</p>
      </header>
      <div class="wrap">
        ${GROUPS.map(([id, title, sub]) => html`<section class="section" aria-labelledby="g-${id}">
          <h2 class="h3" id="g-${id}">${title}</h2>
          <p class="small muted" style="margin:4px 0 12px">${sub}</p>
          <ul class="list">
            ${idx.people.filter((p) => p.group === id).map((p) => html`<li><a class="list__item" href="/person/${p.id}">
              <span class="avatar${p.id === 'krishna' ? ' avatar--krishna' : ''}" aria-hidden="true">${deva(p)}</span>
              <span class="list__body"><span class="list__title">${p.name}</span><span class="list__sub">${p.role}</span></span>
              <span class="list__trail">${icon('chevron-right', { size: 18 })}</span>
            </a></li>`)}
          </ul>
        </section>`)}
      </div>
    </div>`,
  };
}
